import React from "react";
// ANT DESIGN
import { Button, Tooltip } from "antd";
// UTILS
import floorButtonLabel from "../../../utils/floorButtonLabel";
// INTERFACES
import { BankFloorInterface } from "../../../interfaces/Bank.interface";

interface Props {
  floors: BankFloorInterface[];
  isLoading: boolean;
  isEnabled: (floor: BankFloorInterface) => boolean;
  tooltip: (floor: BankFloorInterface, enabled: boolean) => string;
  onClick: (floor: BankFloorInterface) => void;
}

/**
 * Shared floor-button grid used by Terminal command panels.
 *
 * Renders one circular button per floor; the consumer decides whether each
 * floor is enabled, what tooltip to show, and what to do on click. The text on
 * each button comes from `floorButtonLabel`, which every floor button in
 * monitoring shares so all of them stay in lockstep.
 */
export default function FloorButtonGrid({ floors, isLoading, isEnabled, tooltip, onClick }: Props) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
      {floors.map((floor) => {
        const enabled = isEnabled(floor);
        return (
          <Tooltip key={floor.id} title={tooltip(floor, enabled)}>
            <span>
              <Button
                size="small"
                shape="circle"
                disabled={!enabled || isLoading}
                onClick={() => onClick(floor)}
              >
                {floorButtonLabel(floor)}
              </Button>
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
}
